import React, { useEffect, useState, useRef } from "react";
import "../styles/Video.css";
import RuddiNizz from "../img/thumbnail/RuddiNizz.jpg";



// Video data with thumbnails
const videosData = [
  {
    artist: "La Delio Valdez",
    title: "Pájaro y demonio / B2 Video",
    year: "",
    source: "https://www.youtube.com/embed/YGgaxfzQCbg?si=2ZTnLuz0rNJvvsZp",
    type: "youtube",
    thumbnail: "", 
  },
  {
    artist: "Malandro",
    title: "Ganado / B2 Video",
    year: "",
    source: "https://www.youtube.com/embed/xTZ6InPE4VY?si=-293G_DvkmBcKV7z",
    type: "youtube",
    thumbnail: "", 
  },  
  {
    artist: "Danilo & Lezcano",
    title: "No Cajeties / B2 Video",
    year: "",
    source: "https://www.youtube.com/embed/4fSOl2o1Gso?si=PqfGU4M2a-Uhxkzx",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "ARCE",
    title: "Win Win / Filmamo",
    year: "",
    source: "https://www.youtube.com/embed/6JbYS0JQbR0 ",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "G-SONY",
    title: "Antrax / Filmamo",
    year: "",
    source: "https://www.youtube.com/embed/6w1yTX2qv-w",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "MIKE SOTO",
    title: "Latir",
    year: "",
    source: "https://www.youtube.com/embed/rd_LuCk2zzo?si=ydKO-kImz6584clG",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "RUDDI NIZZ",
    title: "Miro las estrellas",
    year: "",
    source: "https://www.youtube.com/embed/pwWBYhl3jxw",
    type: "youtube",
    thumbnail: RuddiNizz,
  },
  {
    artist: "LXS GEMELXS",
    title: "Stimpy & Ren  / Filmamo",
    year: "",
    source: "https://www.youtube.com/embed/zvcpDbHEcJM",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "AHI SOY YO",
    title: "Filmamo",
    year: "",
    source: "https://www.youtube.com/embed/992q7vpl0C8",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "Suena Eh!",
    title: "Filmamo",
    year: "",
    source: "https://www.youtube.com/embed/em-PN2xDv5Y?si=6bk90lJ88D1cT95G",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "Suena Eh!",
    title: "Filmamo",
    source: "https://www.youtube.com/embed/UEyPmp08oI8?si=mhwtChxuQdbIKQnS",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "Suena Eh!",
    title: "Filmamo",
    source: "https://www.youtube.com/embed/-U9OUipHOwY",
    type: "youtube",
    thumbnail: "",
  },
];

const Video = () => {
  const [visibleVideos, setVisibleVideos] = useState(9); // Mostrar inicialmente 9 videos
  const [isPlaying, setIsPlaying] = useState({});
  const videoRefs = useRef([]); // Array de referencias para cada contenedor de video

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 100) {
        setVisibleVideos((prev) => Math.min(prev + 2, videosData.length));
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handlePlayVideo = (index) => {
    setIsPlaying((prev) => ({ ...prev, [index]: true }));
  };

  useEffect(() => {
    videoRefs.current.forEach((videoRef, index) => {
      if (videoRef) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("appear");
                observer.unobserve(entry.target); // Detener la observación una vez visible
              }
            });
          },
          { threshold: 0.3 }
        );
        observer.observe(videoRef);
      }
    });
  }, [visibleVideos]); // Re-ejecutar cuando visibleVideos cambie

  return (
    <div className="video-page">
      {videosData.slice(0, visibleVideos).map((video, index) => (
        <div
          key={index}
          className="video-container"
          ref={(el) => (videoRefs.current[index] = el)} // Asigna una referencia única a cada contenedor
        >
          <h2 className="gallery-subtitle">
            <span className="agency-title">{video.artist}</span> {video.title}
          </h2>
          <div className="video-wrapper">
            {isPlaying[index] || !video.thumbnail ? (
              <iframe
                className="video"
                src={video.source}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            ) : (
              <img
                src={video.thumbnail}
                alt={video.title}
                className="video-thumbnail"
                onClick={() => handlePlayVideo(index)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Video;